import _ from 'lodash';
import React from 'react';
import { track } from '../../analytics/utils';
import {
  Border,
  Center,
  Container,
  GlossierLogo,
  Grid,
  InteractiveText,
  Margin,
  OneTrustIcon,
  Padding,
  Queue,
  Stack,
  Text,
} from '../../components';
import {
  legalLinks,
  LegalLink,
  footerLinks,
  SocialNetworkIcons,
  FooterLinkWrapper,
} from './shared';

export const FooterMobile = () => {
  return (
    <>
      <Container as="footer">
        <Padding size={[4, 5]}>
          <Stack size={4}>
            <Margin size={[2, 0, 0, 0]} />

            <Grid columns={2}>
              <div>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.about.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.about.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.about.text}
                  </a>
                </FooterLinkWrapper>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.contact.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.contact.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.contact.text}
                  </a>
                </FooterLinkWrapper>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.help.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.help.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.help.text}
                  </a>
                </FooterLinkWrapper>
              </div>
              <div>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.itg.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.itg.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.itg.text}
                  </a>
                </FooterLinkWrapper>
                <FooterLinkWrapper>
                  <a
                    href={footerLinks.returns.href}
                    onClick={() => {
                      track('Footer Clicked', footerLinks.returns.tracking);
                    }}
                    target="_blank"
                  >
                    {footerLinks.returns.text}
                  </a>
                </FooterLinkWrapper>
              </div>
            </Grid>

            <Border borderSize={[1, 0, 0, 0]} borderRole="white2" />

            <Padding size={[4, 0]}>
              <Center>
                <Queue size={4.2}>
                  <SocialNetworkIcons />
                </Queue>
              </Center>
            </Padding>

            <Text textRole="info">
              © {new Date().getFullYear()} Glossier Inc. All rights reserved.
            </Text>

            <Center>
              <Queue size={2}>
                {_.flow(
                  (legalLinks) =>
                    _.map(legalLinks, (legalLink, index) => {
                      const {
                        link,
                        description,
                        trackingDescription,
                        isPrivacyLink,
                      } = legalLink || {};
                      return (
                        <LegalLink
                          href={link}
                          target="_blank"
                          onClick={() => {
                            track('Footer Clicked', trackingDescription);
                          }}
                          key={index}
                        >
                          {description}
                          {isPrivacyLink && (
                            <OneTrustIcon width="30" height="30" />
                          )}
                        </LegalLink>
                      );
                    }),
                  (legalLinks) => _.slice(legalLinks, 0, 2)
                )(legalLinks)}
              </Queue>
            </Center>
            <Center>
              <Queue size={2}>
                {_.flow(
                  (legalLinks) =>
                    _.map(legalLinks, (legalLink, index) => {
                      const {
                        link,
                        description,
                        trackingDescription,
                        isPrivacyLink,
                      } = legalLink || {};
                      return (
                        <LegalLink
                          href={link}
                          onClick={() => {
                            track('Footer Clicked', trackingDescription);
                          }}
                          key={index}
                        >
                          {description}
                          {isPrivacyLink && (
                            <OneTrustIcon width="30" height="30" />
                          )}
                        </LegalLink>
                      );
                    }),
                  (legalLinks) => _.slice(legalLinks, 2, 4)
                )(legalLinks)}
              </Queue>
            </Center>
            <Center>
              <Queue size={1}>
                {_.flow(
                  (legalLinks) =>
                    _.map(legalLinks, (legalLink, index) => {
                      const {
                        link,
                        description,
                        trackingDescription,
                        isPrivacyLink,
                      } = legalLink || {};
                      return (
                        <InteractiveText
                          textRole="info"
                          underlined
                          opacity={0.5}
                          onClick={() => {
                            track('Footer Clicked', trackingDescription);
                            window.open(link, '_blank');
                          }}
                          key={index}
                        >
                          {description}
                          {isPrivacyLink && (
                            <OneTrustIcon width="30" height="30" />
                          )}
                        </InteractiveText>
                      );
                    }),
                  (legalLinks) => _.slice(legalLinks, 4, 5)
                )(legalLinks)}
              </Queue>
            </Center>
            <Padding size={[6, 0]}>
              <Center>
                <GlossierLogo />
              </Center>
            </Padding>
          </Stack>
        </Padding>
      </Container>
    </>
  );
};
